module.exports = __webpack_public_path__ + "static/img/实时业务监控与反馈.b1a8ee47.png";